goog.provide("shadow.js.shim.module$$carbon$icons_react$es$DocumentMultiple_01$default");
shadow.js.shim.module$$carbon$icons_react$es$DocumentMultiple_01$default = shadow.js.require(360, {}).default;
